import { createFeatureSelector, createSelector } from '@ngrx/store';
import { subscriptionFeatureKey, SubscriptionState } from '@store/subscription/subscription.reducer';

const selectSubscriptionFeature = createFeatureSelector<SubscriptionState>(subscriptionFeatureKey);

const selectGlobalSubscriptionsIsLoading = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.isLoading || state.followers.isLoading,
);

const selectFollowers = createSelector(
  selectSubscriptionFeature,
  (state) => state.followers.value,
);
const selectFollowersIsLoading = createSelector(
  selectSubscriptionFeature,
  (state) => state.followers.isLoading,
);
const selectFollowersNextPage = createSelector(
  selectSubscriptionFeature,
  (state) => state.followers.nextPage,
);
const selectFollowersError = createSelector(
  selectSubscriptionFeature,
  (state) => state.followers.error,
);

const selectFollowings = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.value,
);
const selectFollowingsIsLoading = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.isLoading,
);
const selectFollowingsNextPage = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.nextPage,
);
const selectFollowingsError = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.error,
);
const selectActiveFollowingsCount = createSelector(
  selectSubscriptionFeature,
  (state) => state.followings.value
    .filter(user => user.subscriptions?.is_following)
    .length,
);
const selectSelectedBasicTariff = createSelector(
  selectSubscriptionFeature,
  (state) => state.basic.selectedTariff,
);

export const subscriptionSelectors = {
  selectSubscriptionFeature,
  selectGlobalSubscriptionsIsLoading,

  selectFollowers,
  selectFollowersIsLoading,
  selectFollowersNextPage,
  selectFollowersError,

  selectActiveFollowingsCount,
  selectFollowings,
  selectFollowingsIsLoading,
  selectFollowingsNextPage,
  selectFollowingsError,

  selectSelectedBasicTariff,
};


